import SuccessIcon from '@/assets/icons/SuccessIcon.svg';
import { useTranslation } from '@/i18n/client';
import { observer } from 'mobx-react';
import { lazy, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router-dom';
import CommonButton from './components/commonButton';
import styles from './orderCancelSuccess.module.scss';
// 埋点
import { SceneCode } from '@/apis/recommend/recommend.interface';
import {
  EXPOSURE_RECORD as Recommend_EXPOSURE_RECORD,
  sendClickTrack as Recommend_sendClickTrack,
} from '@/tracks/25357';
import { EXPOSURE_RECORD, sendClickTrack, sendPv } from '@/tracks/25369';

const RecommendClient = lazy(() => import('@/components/recommend/recommendClient'));

const OrderCancelSuccess = observer(() => {
  const { t } = useTranslation();
  // const [orderDetails, setOrderDetails] = useState<IOrderDetailRes | null>(null);
  // const [loading, setLoading] = useState<boolean>(true);
  // const [error, setError] = useState<string | null>(null);

  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  const styleId = queryParams.get('styleId') || ''; // 获取styleId
  const orderId = queryParams.get('orderId') || '';
  const initCartNumHandler = () => {
    window?.JDIheader?.initCartNum();
  };

  useEffect(() => {
    sendPv.OrderCenter_CancelSubmit();
    window.scrollTo(0, 0); // 页面跳转时滚动到顶部
  }, []);

  const jumpHomePage = () => {
    sendClickTrack.OrderCancelSubmit_ContinueShopping({ orderId });
    window.location.href = '/';
  };

  const jumpDetailPage = () => {
    sendClickTrack.OrderCancelSubmit_OrderDetail({ orderId });
    navigate(-1);
  };

  return (
    <div className={styles.cancel_success_wrap}>
      <Helmet>
        <title>{t('seo.title.orderCancelSuccess')} | Joybuy</title>
        <meta name='description' content={t('seo.description.orderCancelSuccess')} />
      </Helmet>
      <div className={styles.detail_inner_wrap}>
        <div className={styles.cancel_success_content}>
          <div className={styles.title_style}>
            <SuccessIcon className={styles.title_ico} />
            {t('order.orderDetail.applySuccessModal.modalTitle')}
          </div>
          {/* 已经捡货且实付小于等于5英镑落地页提示 */}
          {styleId === '1' && (
            <div className={styles.desc_style}>{t('order.orderCancelSuccess.descText')}</div>
          )}
          {/* 未捡货，落地页展示申请成功提示文案 */}
          {styleId === '2' && (
            <div className={styles.desc_style}>{t('order.orderCancelSuccess.successDescText')}</div>
          )}
          <div className={styles.btn_group}>
            <CommonButton
              variant={'outlined'}
              onClick={jumpHomePage}
              style={{ width: '174px' }}
              exptag={'exp|' + EXPOSURE_RECORD.OrderCancelSubmit_ContinueShoppingExpo}
              data-exptag-config={JSON.stringify({
                useClick: false,
                stay_duration: 0.3,
                repeated: false,
                area_rate: 0.5,
              })}
              data-exptag-json-param={JSON.stringify({ orderId })}
            >
              {t('order.orderDetail.applySuccessModal.shoppingBtn')}
            </CommonButton>
            <CommonButton
              variant={'contained'}
              onClick={jumpDetailPage}
              style={{ width: '174px', marginLeft: '12px' }}
              exptag={'exp|' + EXPOSURE_RECORD.OrderCancelSubmit_OrderDetailExpo}
              data-exptag-config={JSON.stringify({
                useClick: false,
                stay_duration: 0.3,
                repeated: false,
                area_rate: 0.5,
              })}
              data-exptag-json-param={JSON.stringify({ orderId })}
            >
              {t('order.orderCancelSuccess.orderDetailBtn')}
            </CommonButton>
          </div>
        </div>
        <RecommendClient
          sceneCode={SceneCode.AFTER_SALES}
          trackParams={{
            RecomSku_Expo: Recommend_EXPOSURE_RECORD.OrderCenter_CancelSubmit_RecomSku_Expo,
            RecomSku_Tab_Expo: Recommend_EXPOSURE_RECORD.OrderCenter_CancelSubmit_RecomSku_Tab_Expo,
            RecomSku_Addcart_Expo:
              Recommend_EXPOSURE_RECORD.OrderCenter_CancelSubmit_RecomSku_Addcart_Expo,
            productClick: Recommend_sendClickTrack.OrderCenter_CancelSubmit_RecomSku,
            tabClick: Recommend_sendClickTrack.OrderCenter_CancelSubmit_RecomSku_Tab,
            addCartClick: Recommend_sendClickTrack.OrderCenter_CancelSubmit_RecomSku_Addcart,
          }}
        />
      </div>
    </div>
  );
});

export default OrderCancelSuccess;
